(function () {
  if (window.__skeiPromoV1Initialized) return;
  window.__skeiPromoV1Initialized = true;
  var STORAGE_KEY = "skei_active_ad_promo";
  var DAYS_TO_KEEP = 7;
  var MAX_INIT_ATTEMPTS = 80;
  var INIT_RETRY_DELAY = 25;

  function now() {
    return new Date().getTime();
  }

  function getExpiryTimestamp() {
    return now() + DAYS_TO_KEEP * 24 * 60 * 60 * 1000;
  }

  function getUrlParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  function getConfig() {
    var raw = window.SKEI_AD_PROMOS || {};

    return {
      promos: raw.promos || {},
      adIdMap: raw.adIdMap || {}
    };
  }

  function configIsReady() {
    return !!(
      window.SKEI_AD_PROMOS &&
      window.SKEI_AD_PROMOS.promos &&
      Object.keys(window.SKEI_AD_PROMOS.promos).length
    );
  }

  function getPromoByPromoId(promoId) {
    var config = getConfig();

    if (!promoId || !config.promos[promoId]) {
      return null;
    }

    return {
      promo_id: promoId,
      promo: config.promos[promoId]
    };
  }

  function getPromoByAdId(adId) {
    var config = getConfig();

    if (!adId || !config.adIdMap) {
      return null;
    }

    var matchedPromoId = null;

    Object.keys(config.adIdMap).some(function (promoId) {
      var adIds = config.adIdMap[promoId];

      if (typeof adIds === "string") {
        adIds = adIds.split(",").map(function (item) {
          return item.trim();
        });
      }

      if (!Array.isArray(adIds)) {
        return false;
      }

      if (adIds.indexOf(adId) !== -1) {
        matchedPromoId = promoId;
        return true;
      }

      return false;
    });

    if (!matchedPromoId) {
      return null;
    }

    return getPromoByPromoId(matchedPromoId);
  }

  function savePromo(promoId, sourceKey, sourceValue, promo) {
    if (!promoId || !promo || !promo.products || !promo.products.length) return;

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          promo_id: promoId,
          source_key: sourceKey || "",
          source_value: sourceValue || "",
          name: promo.name || "",
          headline: promo.headline || "",
          products: promo.products,
          expires_at: getExpiryTimestamp()
        })
      );
    } catch (e) {}
  }

  function getSavedPromo() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var promo = JSON.parse(raw);

      if (!promo.expires_at || promo.expires_at < now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      if (!promo.products || !promo.products.length) return null;

      return promo;
    } catch (e) {
      return null;
    }
  }

  function capturePromoFromUrl() {
    var directPromoId = getUrlParam("skei_promo");
    var adId = getUrlParam("ad_id");

    if (directPromoId) {
      var directMatch = getPromoByPromoId(directPromoId);

      if (directMatch) {
        savePromo(
          directMatch.promo_id,
          "skei_promo",
          directPromoId,
          directMatch.promo
        );
        return true;
      }
    }

    if (adId) {
      var adMatch = getPromoByAdId(adId);

      if (adMatch) {
        savePromo(
          adMatch.promo_id,
          "ad_id",
          adId,
          adMatch.promo
        );
        return true;
      }
    }

    return false;
  }

  function uniqueArray(items) {
    var seen = {};
    var result = [];

    items.forEach(function (item) {
      if (!item || seen[item]) return;
      seen[item] = true;
      result.push(item);
    });

    return result;
  }

  function productItemToHandle(item) {
    if (!item) return null;
    if (typeof item === "string") return item;
    if (item.handle) return item.handle;
    return null;
  }

  function getPromoHandles(promo) {
    return uniqueArray(
      (promo.products || [])
        .map(productItemToHandle)
        .filter(Boolean)
    );
  }

  function makeUniqueId() {
    return Date.now() + "-" + Math.random().toString(36).slice(2, 10);
  }

  function replaceUniqueId(html) {
    var uniqueId = makeUniqueId();
    return html.split("UNIQUE_ID").join(uniqueId);
  }

  function getPromoCardTemplate(handle) {
    var templates = document.querySelectorAll("[data-skei-promo-card-template]");

    for (var i = 0; i < templates.length; i++) {
      if (templates[i].getAttribute("data-skei-product-handle") === handle) {
        return templates[i];
      }
    }

    return null;
  }

  function getPromoCardHtml(handle) {
    var template = getPromoCardTemplate(handle);

    if (!template) {
      return "";
    }

    return replaceUniqueId(template.innerHTML.trim());
  }

  function sliderOptionsHtml(productsCount) {
    var navigationDOM = [
      '<span class="css-slider-button css-slider-prev" style="display:none">',
      '<svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg">',
      '<path clip-rule="evenodd" d="m4.32845 10.0708-4.18198-4.18194c-.195261-.19526-.195261-.51185 0-.70711l4.18198-4.181979c.19527-.195262.51185-.195262.70711 0 .19526.195259.19526.511849 0 .707109l-3.32843 3.32842s-.70713.4647-.00002 1l3.32845 3.32843c.19526.19526.19526.51185 0 .70707-.19526.1953-.51185.1953-.70711 0z" fill="#000" fill-rule="evenodd"/>',
      '</svg>',
      '</span>',
      '<span class="css-slider-button css-slider-next" style="display:none">',
      '<svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg">',
      '<path clip-rule="evenodd" d="m.853555.999962 4.181985 4.181978c.19526.19526.19526.51185 0 .70711l-4.181983 4.18195c-.195263.1953-.511845.1953-.707108 0-.1952631-.19523-.1952632-.51181 0-.70708l3.328431-3.32842s.70713-.4647.00002-1l-3.328453-3.32843c-.1952626-.19526-.1952627-.51185 0-.707108.195263-.195262.511845-.195262.707108 0z" fill="#000" fill-rule="evenodd"/>',
      '</svg>',
      '</span>'
    ].join("");

    return JSON.stringify({
      selector: ".product-item",
      groupCells: true,
      navigationDOM: navigationDOM,
      thumbnailsDOM:
        '<div class="css-slider-dot-navigation" style="display:none;--size:' +
        productsCount +
        '"></div>'
    }).replace(/"/g, "&quot;");
  }

  function buildSliderHtml(cardsHtml, section) {
    var layout = section.getAttribute("data-skei-promo-layout") || "grid-4 grid-portable-3 grid-lap-2";
    var mobileLayout = section.getAttribute("data-skei-promo-layout-mobile") || "grid-palm-2";

    return [
      '<css-slider',
      ' data-options="' + sliderOptionsHtml(cardsHtml.length) + '"',
      ' class="css-slider css-slider--bottom-navigation"',
      '>',
      '<div class="grid grid--slider ' + layout + " " + mobileLayout + '">',
      cardsHtml.join(""),
      "</div>",
      "</css-slider>"
    ].join("");
  }

  function setPromoHeadline(section, promo) {
    if (!section || !promo || !promo.headline) return;

    var headline = String(promo.headline).trim();
    if (!headline) return;

    var headlineElement =
      section.querySelector("[data-skei-promo-headline]") ||
      section.querySelector(".section-heading__title") ||
      section.querySelector(".section-header__title") ||
      section.querySelector(".section-title") ||
      section.querySelector("h2") ||
      section.querySelector("h3");

    if (!headlineElement) return;

    if (headlineElement.closest("[data-skei-promo-slider-target]")) return;
    if (headlineElement.closest("[data-js-product-item]")) return;

    headlineElement.textContent = headline;
  }

  function wakeLazyImages(section) {
    section.querySelectorAll(".lazy-image img").forEach(function (img) {
      var figure = img.closest(".lazy-image");
      if (!figure) return;

      if (img.complete) {
        figure.classList.add("lazyloaded");
        figure.classList.add("lazy-image--revealed");
      }
    });
  }

  function initializePromoQuickBuyFallback(root) {
    if (!root) return;

    root.querySelectorAll("[data-js-product-item]").forEach(function (card) {
      if (card.getAttribute("data-skei-quick-buy-fallback-ready") === "true") return;

      card.setAttribute("data-skei-quick-buy-fallback-ready", "true");

      var variants = card.querySelector("product-variants");
      var form = card.querySelector("form");
      var hiddenInput = form ? form.querySelector('input[name="id"]') : null;
      var button = card.querySelector("[data-js-product-add-to-cart]");
      var buttonText = card.querySelector("[data-js-product-add-to-cart-text]");

      if (!variants || !form || !hiddenInput || !button || !buttonText) return;

      function getAddToCartText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_add_to_cart_button
        ) {
          return KROWN.settings.locales.products_add_to_cart_button;
        }

        return "In den Warenkorb";
      }

      function getSoldOutText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_sold_out_variant
        ) {
          return KROWN.settings.locales.products_sold_out_variant;
        }

        return "Ausverkauft";
      }

      function getVariantRequiredText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_variant_required
        ) {
          return KROWN.settings.locales.products_variant_required;
        }

        return "Zuerst GrÃ¶ÃŸe wÃ¤hlen";
      }

      function getAllVariantInputs() {
        return Array.prototype.slice.call(
          variants.querySelectorAll('input[type="radio"][data-variant-id]')
        );
      }

      function hasAnyAvailableVariant() {
        return getAllVariantInputs().some(function (input) {
          return input.getAttribute("data-available") === "true";
        });
      }

      function getSelectedInput() {
        return (
          variants.querySelector('input[type="radio"]:checked') ||
          variants.querySelector('input[type="radio"][data-selected]')
        );
      }

      function setButtonEnabled(variantId) {
        hiddenInput.value = variantId;

        button.classList.remove("disabled");
        form.classList.remove("disabled-cart");
        form.classList.remove("unavailable-variant");

        buttonText.textContent = getAddToCartText();
      }

      function setButtonDisabledRequired() {
        button.classList.add("disabled");
        form.classList.add("disabled-cart");
        form.classList.add("unavailable-variant");

        buttonText.innerHTML =
          getAddToCartText() +
          '<br><span class="button__subtext">(' +
          getVariantRequiredText() +
          ")</span>";
      }

      function setButtonSoldOut() {
        button.classList.add("disabled");
        form.classList.add("disabled-cart");
        form.classList.add("unavailable-variant");

        buttonText.textContent = getSoldOutText();
      }

      function updateFromSelection() {
        if (!hasAnyAvailableVariant()) {
          setButtonSoldOut();
          return;
        }

        var selectedInput = getSelectedInput();

        if (!selectedInput) {
          setButtonDisabledRequired();
          return;
        }

        var variantId = selectedInput.getAttribute("data-variant-id");
        var available = selectedInput.getAttribute("data-available");

        if (!variantId) {
          setButtonDisabledRequired();
          return;
        }

        if (available === "false") {
          setButtonSoldOut();
          return;
        }

        setButtonEnabled(variantId);
      }

      variants.addEventListener("change", function (event) {
        var target = event.target;

        if (!target || !target.matches('input[type="radio"]')) return;

        variants.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.removeAttribute("data-selected");
          input.removeAttribute("checked");
        });

        target.setAttribute("data-selected", "");
        target.setAttribute("checked", "checked");

        updateFromSelection();
      });

      variants.addEventListener("click", function (event) {
        var input = event.target.closest('input[type="radio"]');

        if (!input) return;

        window.setTimeout(function () {
          input.checked = true;
          input.setAttribute("data-selected", "");
          updateFromSelection();
        }, 0);
      });

      form.addEventListener(
        "submit",
        function (event) {
          updateFromSelection();

          if (button.classList.contains("disabled")) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        },
        true
      );

      updateFromSelection();
    });
  }

  function resetSlider(section) {
    var slider = section.querySelector("css-slider");

    if (!slider) return;

    function runReset() {
      if (typeof slider.afterAppend === "function") {
        slider.afterAppend();
      }

      if (typeof slider.resetSlider === "function") {
        slider.resetSlider(false, true);
      }

      if (typeof slider.checkSlide === "function") {
        slider.checkSlide();
      }

      window.dispatchEvent(new Event("resize"));
    }

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(runReset);
      });
    } else {
      window.setTimeout(runReset, 60);
    }
  }

  function resetPromoVariantSliders(section) {
    if (!section) return;

    window.setTimeout(function () {
      section.querySelectorAll("[data-js-product-item] quick-buy css-slider").forEach(function (slider) {
        if (typeof slider.resetSlider === "function") {
          slider.resetSlider(false, false);
        }
      });
    }, 30);
  }

  function renderSection(section, promo) {
    var target = section.querySelector("[data-skei-promo-slider-target]");
    var limit = parseInt(section.getAttribute("data-skei-promo-products-limit") || "8", 10);
    var productPath = window.location.pathname.match(/\/products\/([^/]+)/);
    var currentHandle = productPath ? decodeURIComponent(productPath[1]) : "";
    var handles = getPromoHandles(promo).filter(function (handle) {
      return handle !== currentHandle;
    }).slice(0, limit);

    if (!target || !handles.length) {
      section.style.display = "none";
      return;
    }

    var cardsHtml = handles
      .map(function (handle) {
        return getPromoCardHtml(handle);
      })
      .filter(function (html) {
        return html && html.indexOf("product-item") !== -1;
      });

    if (!cardsHtml.length) {
      section.style.display = "none";
      target.innerHTML = "";
      return;
    }

    setPromoHeadline(section, promo);

    section.style.display = "";
    target.innerHTML = buildSliderHtml(cardsHtml, section);

    wakeLazyImages(section);
    initializePromoQuickBuyFallback(section);
    resetSlider(section);
    resetPromoVariantSliders(section);
  }



  // Promo sales attribution v1: no visitor counters or external endpoints.
  var EXPOSURE_KEY = "skei_promo_banner_exposure_v1";
  function readJSON(key) { try { return JSON.parse(localStorage.getItem(key) || "null"); } catch (e) { return null; } }
  function writeJSON(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function fingerprint(text) {
    var hash = 2166136261;
    for (var i = 0; i < text.length; i++) { hash ^= text.charCodeAt(i); hash = Math.imul(hash, 16777619); }
    return (hash >>> 0).toString(36);
  }
  function chooseBanner(promo, settings) {
    var current = promo && getPromoByPromoId(promo.promo_id);
    if (!current) return null;
    var config = current.promo.hero || {};
    var images = config.images || [];
    var handles = getPromoHandles(current.promo);
    function find(handle) { return images.find(function (p) { return p.handle === handle && p.image && p.url; }); }
    if (settings.enabled === false) return { mode: "control" };
    if (settings.productIndex != null) {
      var index = Number(settings.productIndex);
      if (!Number.isInteger(index) || index < 1 || !find(handles[index - 1])) return { mode: "control" };
      return { mode: "override", product: find(handles[index - 1]) };
    }
    var round = String(config.round || "").trim();
    var candidates = uniqueArray(config.candidateHandles || []).filter(function (handle) { return handles.indexOf(handle) !== -1 && find(handle); }).map(find);
    if (config.testEnabled === true && round && candidates.length >= 2) {
      // Sorting avoids starting a new experiment just because its list was reordered.
      candidates.sort(function (a, b) { return a.id.localeCompare(b.id); });
      var key = round + ":" + fingerprint(JSON.stringify(candidates.map(function (p) { return [p.id, p.imageId, p.image]; })));
      var storageKey = "skei_banner_assignment_v1:" + promo.promo_id;
      var saved = readJSON(storageKey);
      var selected = saved && saved.key === key && saved.expires_at > now() && candidates.find(function (p) { return p.id === saved.productId; });
      if (!selected) {
        var random = Math.random();
        if (window.crypto && window.crypto.getRandomValues) { var values = new Uint32Array(1); window.crypto.getRandomValues(values); random = values[0] / 4294967296; }
        selected = candidates[Math.floor(random * candidates.length)];
      }
      writeJSON(storageKey, { key: key, productId: selected.id, expires_at: now() + 180 * 86400000 });
      return { mode: "test", product: selected, round: round, key: key };
    }
    var standard = find(config.defaultHandle) || find(handles[0]);
    return standard ? { mode: "standard", product: standard } : { mode: "unseen" };
  }
  function recordBanner(promo, choice) {
    if (!promo) return;
    var product = choice.product || {};
    var value = { promo: promo.promo_id, mode: choice.mode, round: choice.round || "", key: choice.key || "", productId: product.id || "", handle: product.handle || "", imageId: product.imageId || "", image: product.image || "", exposedAt: choice.mode === "unseen" ? "" : new Date().toISOString(), expires_at: promo.expires_at };
    writeJSON(EXPOSURE_KEY, value);
    scheduleAttribution();
  }
  var attributionKeys = ["skei_promo_id", "skei_promo_name", "skei_attribution_version", "skei_test_round", "skei_test_key", "skei_banner_mode", "skei_banner_product_id", "skei_banner_product_handle", "skei_banner_image_id", "skei_banner_image_url", "skei_exposed_at"];
  function attributionAttributes() {
    var attributes = {};
    attributionKeys.forEach(function (key) { attributes[key] = ""; });
    var promo = getSavedPromo();
    if (!promo || !getPromoByPromoId(promo.promo_id)) return attributes;
    var exposure = readJSON(EXPOSURE_KEY);
    if (!exposure || exposure.promo !== promo.promo_id || exposure.expires_at <= now()) exposure = {};
    attributes.skei_promo_id = promo.promo_id;
    attributes.skei_promo_name = promo.name || promo.promo_id;
    attributes.skei_attribution_version = "1";
    attributes.skei_test_round = exposure.round || "";
    attributes.skei_test_key = exposure.key || "";
    attributes.skei_banner_mode = exposure.mode || "unseen";
    attributes.skei_banner_product_id = exposure.productId || "";
    attributes.skei_banner_product_handle = exposure.handle || "";
    attributes.skei_banner_image_id = exposure.imageId || "";
    attributes.skei_banner_image_url = exposure.image || "";
    attributes.skei_exposed_at = exposure.exposedAt || "";
    return attributes;
  }
  var attributionQueue = Promise.resolve();
  var attributionTimer;
  var attributionLastError = "";
  function syncAttribution() {
    attributionQueue = attributionQueue.catch(function () {}).then(async function () {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
      var options = { credentials: "same-origin", headers: { "Accept": "application/json" }, signal: AbortSignal.timeout(4000) };
      var response = await fetch(root + "cart.js", options);
      if (!response.ok) throw new Error("Cart read " + response.status);
      var cart = await response.json();
      var attributes = attributionAttributes();
      var changes = {};
      attributionKeys.forEach(function (key) { if (String((cart.attributes || {})[key] || "") !== attributes[key]) changes[key] = attributes[key]; });
      if (Object.keys(changes).length) {
        response = await fetch(root + "cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ attributes: changes }), signal: AbortSignal.timeout(4000) });
        if (!response.ok) throw new Error("Cart attribution " + response.status);
      }
      attributionLastError = "";
      return true;
    }).catch(function (error) { attributionLastError = error.message; console.warn("Promo attribution:", error.message); return false; });
    return attributionQueue;
  }
  function scheduleAttribution() { clearTimeout(attributionTimer); attributionTimer = setTimeout(syncAttribution, 100); }
  window.SKEI_PROMO_ANALYTICS = { version: "1", sync: syncAttribution, getStatus: function () { return { attributes: attributionAttributes(), error: attributionLastError }; } };
  function startAttribution() {
    capturePromoFromUrl();
    scheduleAttribution();
    ["cart:updated", "cart:change", "cart:refresh", "aov:cart"].forEach(function (name) { document.addEventListener(name, scheduleAttribution); });
    window.addEventListener("pageshow", scheduleAttribution);
    window.addEventListener("storage", function (event) { if (event.key === STORAGE_KEY || event.key === EXPOSURE_KEY) scheduleAttribution(); });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) scheduleAttribution(); });
    // Wait briefly before standard cart checkout; never prevent shopping on an attribution error.
    var replaying = false;
    function beforeCheckout(event, resume) {
      if (replaying || event.defaultPrevented) return;
      event.preventDefault(); event.stopImmediatePropagation();
      Promise.race([syncAttribution(), new Promise(function (resolve) { setTimeout(resolve, 1800); })]).finally(function () { replaying = true; try { resume(); } finally { replaying = false; } });
    }
    document.addEventListener("click", function (event) {
      if (!(event.target instanceof Element)) return;
      var target = event.target.closest('a[href],button[name="checkout"],input[name="checkout"]');
      if (!target || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      var url = target.tagName === "A" ? new URL(target.href, location.origin) : null;
      var checkout = url ? url.origin === location.origin && /\/checkout\/?$/.test(url.pathname) : true;
      if (checkout) beforeCheckout(event, function () { target.click(); });
    }, true);
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var action = new URL(form.action, location.origin);
      if (action.origin !== location.origin) return;
      if (/\/checkout\/?$/.test(action.pathname) || (/\/cart\/?$/.test(action.pathname) && event.submitter && event.submitter.name === "checkout")) {
        var submitter = event.submitter;
        beforeCheckout(event, function () { form.requestSubmit(submitter); });
      }
      if (/\/cart\/add/.test(action.pathname)) setTimeout(scheduleAttribution, 800);
    }, true);
  }

  var promoHeroState = null;
  window.SKEI_PROMO_HERO_CONFIG = Object.assign(
    { enabled: true, productIndex: null },
    window.SKEI_PROMO_HERO_CONFIG || {}
  );
  window.refreshSkeiPromoHero = function () {
    renderPromoHero(getSavedPromo());
  };
  function resetPromoHero() {
    if (window.SKEI_PROMO_HERO_BOOT) window.SKEI_PROMO_HERO_BOOT.release();
    if (!promoHeroState) return;
    promoHeroState.cancelled = true;
    promoHeroState.hero.classList.remove("skei-promo-hero-active");
    if (promoHeroState.link) promoHeroState.link.remove();
    if (promoHeroState.style) promoHeroState.style.remove();
    promoHeroState = null;
  }
  function renderPromoHero(promo) {
    var hero = document.querySelector(".ibkV3lvDSNTg91lUI");
    if (!hero || !window.matchMedia("(max-width:767px)").matches) { resetPromoHero(); return; }
    var choice = chooseBanner(promo, window.SKEI_PROMO_HERO_CONFIG || {});
    if (!choice || !choice.product) { resetPromoHero(); if (choice) recordBanner(promo, choice); return; }
    var firstHandle = choice.product.handle;
    var source = choice.product.image;
    var destination = choice.product.url;
    var imageUrl, productUrl;
    try {
      imageUrl = new URL(source, location.origin);
      productUrl = new URL(destination, location.origin);
      if (imageUrl.protocol !== "https:" || productUrl.origin !== location.origin) { resetPromoHero(); return; }
    } catch (error) { resetPromoHero(); return; }
    var key = promo.promo_id + "|" + choice.mode + "|" + (choice.key || "") + "|" + imageUrl.href + "|" + productUrl.href;
    if (promoHeroState && promoHeroState.hero === hero && promoHeroState.key === key) return;
    resetPromoHero();
    recordBanner(promo, {mode: "unseen"});
    var state = {hero: hero, key: key, cancelled: false};
    promoHeroState = state;
    if (window.SKEI_PROMO_HERO_BOOT) {
      window.SKEI_PROMO_HERO_BOOT.hold(function () {
        if (promoHeroState === state) resetPromoHero();
      });
    }
    var image = new Image();
    image.crossOrigin = "anonymous";
    image.alt = "";
    image.width = 864;
    image.height = 1080;
    image.decoding = "async";
    image.fetchPriority = "high";
    image.onload = function () {
      if (state.cancelled || !hero.isConnected) return;
      var rgb = "238 238 236";
      try {
        var canvas = document.createElement("canvas");
        canvas.width = canvas.height = 64;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, 64, 64);
        var pixels = ctx.getImageData(0, 0, 64, 64).data;
        var sums = [0, 0, 0], total = 0;
        for (var i = 0; i < pixels.length; i += 4) {
          var channels = [pixels[i], pixels[i + 1], pixels[i + 2]];
          var saturation = (Math.max.apply(null, channels) - Math.min.apply(null, channels)) / 255;
          var weight = (0.1 + saturation) * pixels[i + 3] / 255;
          for (var j = 0; j < 3; j++) sums[j] += channels[j] * weight;
          total += weight;
        }
        if (total) {
          var white = 0.85;
          rgb = sums.map(function (sum) {return Math.round(sum / total * (1 - white) + 255 * white);}).join(" ");
        }
      } catch (error) {console.warn("Promo hero: color analysis unavailable; using neutral background.", error);}
      var link = document.createElement("a");
      link.className = "skei-promo-hero-link";
      link.href = productUrl.href;
      link.setAttribute("aria-label", choice.product.title || firstHandle);
      link.appendChild(image);
      var style = document.createElement("style");
      style.textContent = [
        '.skei-promo-hero-link {display:none!important;}',
        '@media(max-width:767px){',
        '.ibkV3lvDSNTg91lUI.skei-promo-hero-active {--skei-hero-rgb:' + rgb + ';position:relative!important;isolation:isolate;overflow:hidden!important;background:rgb(var(--skei-hero-rgb))!important;}',
        '.skei-promo-hero-active > img {visibility:hidden!important;}',
        '.skei-promo-hero-active > .skei-promo-hero-link {display:block!important;position:absolute!important;inset:auto 0 0!important;width:100%!important;height:auto!important;aspect-ratio:4 / 5;padding:0!important;margin:0!important;z-index:0;}',
        '.skei-promo-hero-link > img {display:block;width:100%;height:100%;object-fit:contain;object-position:center bottom;}',
        '.skei-promo-hero-link::after {content:"";position:absolute;inset:0;pointer-events:none;background:linear-gradient(to bottom,rgb(var(--skei-hero-rgb) / 1) 0%,rgb(var(--skei-hero-rgb) / 0.9) 8%,rgb(var(--skei-hero-rgb) / 0.45) 20%,rgb(var(--skei-hero-rgb) / 0) 35%);}',
        '.skei-promo-hero-link:focus-visible {outline:3px solid #222!important;outline-offset:-4px;}',
        '.skei-promo-hero-active > .irYv0lNiSWGL4C23E {position:relative!important;z-index:1!important;pointer-events:none;}',
        '.skei-promo-hero-active > .irYv0lNiSWGL4C23E :is(a,button,input,select,textarea){pointer-events:auto;}',
        '}'
      ].join('\n');
      state.link = link;
      state.style = style;
      document.head.appendChild(style);
      hero.appendChild(link);
      hero.classList.add("skei-promo-hero-active");
      recordBanner(promo, choice);
      if (window.SKEI_PROMO_HERO_BOOT) window.SKEI_PROMO_HERO_BOOT.release();
    };
    image.onerror = function () {
      if (state.cancelled) return;
      if (image.crossOrigin) {image.removeAttribute("crossorigin");image.src = imageUrl.href;return;}
      if (promoHeroState === state) resetPromoHero();
      console.warn("Promo hero: image unavailable; keeping original banner.");
    };
    image.src = imageUrl.href;
  }

  function runHomepagePromo() {
    capturePromoFromUrl();

    var promo = getSavedPromo();
    renderPromoHero(promo);
    var sections = document.querySelectorAll("[data-skei-promo-featured-products]");

    if (!sections.length) return;

    if (!promo) {
      sections.forEach(function (section) {
        section.style.display = "none";
      });
      return;
    }

    sections.forEach(function (section) {
      renderSection(section, promo);
    });
  }

  function initHomepagePromo(attempt) {
    attempt = attempt || 0;

    var hasSection = document.querySelector("[data-skei-promo-featured-products]");
    var hasSavedPromo = !!getSavedPromo();
    var hasUrlPromoParam = !!(getUrlParam("skei_promo") || getUrlParam("ad_id"));

    if (!hasSection && attempt < MAX_INIT_ATTEMPTS) {
      window.setTimeout(function () {
        initHomepagePromo(attempt + 1);
      }, INIT_RETRY_DELAY);
      return;
    }

    if (!hasSection) return;

    if (!configIsReady() && hasUrlPromoParam && attempt < MAX_INIT_ATTEMPTS) {
      window.setTimeout(function () {
        initHomepagePromo(attempt + 1);
      }, INIT_RETRY_DELAY);
      return;
    }

    if (!hasSavedPromo && !hasUrlPromoParam) {
      runHomepagePromo();
      return;
    }

    runHomepagePromo();
  }

  startAttribution();
  window.matchMedia("(max-width:767px)").addEventListener("change", function () { renderPromoHero(getSavedPromo()); });
  initHomepagePromo(0);

  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(function () {
      initHomepagePromo(0);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHomepagePromo(0);
  });

  document.addEventListener("shopify:section:load", function () {
    initHomepagePromo(0);
  });
})();